import {AsyncComponent} from '@modifi/code-splitting'
import {FullScreenLoader} from '@modifi/ui'

export default AsyncComponent({
  importThunk: () => import(/* webpackChunkName: "website-cms-page" */ '.'),
  loader: FullScreenLoader,
  modules: ['website-cms-page'],
  webpack: [require.resolveWeak('.')],
})
